import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-lg-25 letter-spacing" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-20" }
const _hoisted_4 = { class: "card-title fw-bold mb-0" }
const _hoisted_5 = { class: "d-flex align-items-center gap-3" }
const _hoisted_6 = { class: "form-check form-switch mb-0" }
const _hoisted_7 = {
  class: "form-check-label",
  for: "onlyUnread"
}
const _hoisted_8 = {
  key: 0,
  class: "text-muted text-center py-4 mb-0"
}
const _hoisted_9 = { class: "list-group list-group-flush" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-block fw-semibold" }
const _hoisted_12 = {
  key: 0,
  class: "d-block text-muted fs-14"
}
const _hoisted_13 = { class: "d-block text-muted fs-13 mt-1" }
const _hoisted_14 = { class: "text-center mt-3" }
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("header.notifications")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              id: "onlyUnread",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyUnread) = $event)),
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.load(true)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.onlyUnread]
            ]),
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("header.onlyUnread")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary btn-sm",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.markAllRead && _ctx.markAllRead(...args)))
          }, _toDisplayString(_ctx.$t("header.markAllRead")), 1)
        ])
      ]),
      (!_ctx.items.length && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t("header.noNotifications")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (n) => {
          return (_openBlock(), _createElementBlock("button", {
            key: n.id,
            type: "button",
            class: _normalizeClass(['list-group-item list-group-item-action text-start notif-row', { 'notif-row--unread': !n.read_at }]),
            onClick: ($event: any) => (_ctx.open(n))
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(n.title), 1),
            (n.body)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(n.body), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatDate(n.created_at)), 1)
          ], 10, _hoisted_10))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15))
          : (_ctx.hasMore)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-light",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.load(false)))
              }, _toDisplayString(_ctx.$t("header.loadMore")), 1))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}